import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import Icon from '@ellucian/ds-icons/lib/es6/Icon';
import {
    Tooltip,
    IconButton
} from '@ellucian/react-design-system/core';
import { useIntl } from 'react-intl';
import { useHistory, generatePath } from 'react-router-dom';
import { routes } from '../../Helpers/Configuration';
import { canViewProcessingHistory } from '../../../utilities/actionCheck';

const ExecutionHistoryButton = props => {
    const intl = useIntl();
    const history = useHistory();
    const { hasPermission } = props;
    const canViewExecutionHistory = useMemo(() => canViewProcessingHistory(hasPermission), [hasPermission]);

    const navigateToTransferJobs = useCallback(() => {
        const route = generatePath(routes.importsTransferJob, { id: props.id });        
        history.push(route, { from:props.locationState } ); 
    }, [history]);
    
    return (
        <>
            {canViewExecutionHistory &&
                <Tooltip title={intl.formatMessage({ id: 'adminProspectsImportsExecutionHistory' })}>
                    <IconButton onClick={navigateToTransferJobs} color="secondary">
                        <Icon name="history" aria-label={intl.formatMessage({ id: 'adminProspectsImportsExecutionHistory' })} />
                    </IconButton>
                </Tooltip>
            }
        </>
    );
};
ExecutionHistoryButton.propTypes = {
    id: PropTypes.string.isRequired,
    locationState: PropTypes.string,
    hasPermission: PropTypes.func
};
export default ExecutionHistoryButton;
